class CodeParachuteMegaMenu {
    constructor(megaMenu) {
        this.megaMenu = megaMenu
        this.isShowing = false
        this.header = document.querySelector('.codeparachute-header')
        this.leftMenu = this.megaMenu.querySelector('.left-menu')
        this.rightMenu = this.megaMenu.querySelector('.right-menu')
        this.disabled = window.innerWidth < 900
        this.init()
    }

    setTop() {
        const bottomOfHeader = this.header.getBoundingClientRect().height
        this.megaMenu.style.top = `${bottomOfHeader}px`
    }
    
    init() {
        this.setTop()

        function hasParent(element, parentClassName) {
            while (element) {
                if (element.classList && element.classList.contains(parentClassName)) {
                    return true;
                }
                element = element.parentElement;
            }
            return false;
        }
        const triggers = document.querySelectorAll('.menu-item.mega-menu')
        triggers.forEach((trigger) => {
            trigger.addEventListener('mouseover', () => this.showMenu(trigger))
        })

        const otherMenuItems = document.querySelectorAll('.menu-item:not(.mega-menu)')
        otherMenuItems.forEach((menuItem) => {
            menuItem.addEventListener('mouseover', () => {
                if (this.disabled) return
                const hasMegaMenuParent = hasParent(menuItem, 'mega-menu')
                if (hasMegaMenuParent) return
                else this.hideMenu()
            })
        })

        this.megaMenu.addEventListener('mouseover', () => this.onMouseOverMegaMenu())
        this.megaMenu.addEventListener('mouseleave', () => this.onMouseLeaveMegaMenu())

        window.addEventListener('resize', (e) => {
			if (window.innerWidth < 900) {
                this.hideMenu()
                this.disabled = true
            }
            else {
                this.disabled = false
                this.setTop()
            }
		})
    }

    onMouseOverMegaMenu() {
        if (this.disabled) return
        if (!this.isShowing) return
        this.isOverMegaMenu = true
    }

    onMouseLeaveMegaMenu() {
        if (this.disabled) return
        if (!this.isShowing) return
        if (this.isOverMegaMenu) this.hideMenu()
        this.isOverMegaMenu = false
    }

    getMenusFromParent(parentMenuElement) {
        const menus = parentMenuElement.querySelectorAll('.sub-menu')
        if (menus.length === 0) return { mainMenu: null, subMenus: [] }
        if (menus.length === 1) return { mainMenu: menus[0], subMenus: [] }
        if (menus.length > 1) {
            const mainMenu = menus[0]
            const subMenus = []
            for (let i = 1; i < menus.length; i++) {
                subMenus.push(menus[i])
            }
            return { mainMenu, subMenus }
        }
        return { mainMenu: null, subMenus: [] }
    }

    cloneAndRemoveSubMenus(menuElement) {
        const menuElementClone = menuElement.cloneNode(true)
        //Remove sub-menus from menuElementClone
        menuElementClone.querySelectorAll('.sub-menu').forEach((subMenu) => {
            subMenu.remove()
        })
        return menuElementClone
    }

    renderMainMenu(menus) {
        const mainMenuElement = menus.mainMenu
        if (!mainMenuElement) return
        const mainMenu = this.cloneAndRemoveSubMenus(mainMenuElement)
        this.leftMenu.innerHTML = mainMenu.innerHTML
    }

    renderCurrentSubMenu(menuElement) {
        if (!menuElement) {
            this.rightMenu.innerHTML = ''
            return
        }
        this.rightMenu.innerHTML = this.cloneAndRemoveSubMenus(menuElement).innerHTML
    }

    showMenu(parentMenuElement) {
        if (this.disabled) return
        if (this.isShowing) return
        const menus = this.getMenusFromParent(parentMenuElement)
        if (!menus.mainMenu) return
        // window.scrollTo({
        //     top: 0,
        //     left: 0,
        //     behavior: 'auto'
        // });
        this.renderMainMenu(menus)
        if (menus.subMenus.length > 0) {
            this.renderCurrentSubMenu(menus.subMenus[0])
            const menuItems = this.leftMenu.querySelectorAll('.menu-item')
            for (let i = 0; i < menuItems.length; i++) {
                const subMenu = menus.subMenus[i]
                const menuItem = menuItems[i]
                if (i === 0) menuItem.classList.add('hover')
                menuItem.addEventListener('mouseover', () => {
                    this.renderCurrentSubMenu(subMenu)
                    menuItem.classList.add('hover')
                    for (let j = 0; j < menuItems.length; j++) {
                        if (j !== i) menuItems[j].classList.remove('hover')
                    }
                })
            }
        }
        // BslHtml.get().lock()
        this.megaMenu.classList.add('show')
        this.isShowing = true
    }

    hideMenu() {
        if (!this.isShowing && !this.isOverMegaMenu) return
        // BslHtml.get().unlock()
        this.megaMenu.classList.remove('show')
        this.isShowing = false
        this.isOverMegaMenu = false
    }
}

const megaMenu = document.querySelector('.codeparachute-mega-menu')
new CodeParachuteMegaMenu(megaMenu)